import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { UpdateVisitDTO } from "./type";
import type { OkResponse } from "@typings/api";

export async function updateVisit(
  visitId: string,
  data: UpdateVisitDTO,
): Promise<OkResponse> {
  const response = await apiClient.patch<OkResponse>(
    apiPaths.visits.update(visitId),
    data,
  );
  return response.data;
}
